export let videoElement = null;
export let canvasElement = null;

export function bindCameraElements(video, canvas, size = {}) {
  videoElement = video || null;
  canvasElement = canvas || null;
  if (videoElement) {
    videoElement.autoplay = true;
    videoElement.playsInline = true;
    videoElement.muted = true;
    videoElement.volume = 0;
  }
  if (canvasElement && size.width && size.height) {
    canvasElement.width = size.width;
    canvasElement.height = size.height;
  }
  return getCameraElements();
}

export function clearCameraElements(video, canvas) {
  if (videoElement === video) videoElement = null;
  if (canvasElement === canvas) canvasElement = null;
}

export function getCameraElements() {
  return { videoEl: videoElement, canvasEl: canvasElement };
}

